
export enum VerseCategory {
  WEDDING = 'wedding',
  BIRTHDAY = 'birthday',
  COMMUNION = 'communion',
  BAPTISM = 'baptism',
  INSPIRATIONAL = "inspirational"
}

export enum Language {
  ENGLISH = "en",
  ENGLISH_US = "en_US",
  SPANISH = "es",
  FRENCH = "fr",
  GERMAN = "de",
  CHINESE = "zh",
  HINDI = "hi",
  ARABIC = "ar",
  PORTUGUESE = "pt",
  RUSSIAN = "ru",
  JAPANESE = "ja",
  MALAYALAM = "ml",
  TAMIL = "ta"
}


export interface BibleVerse {
  id: number;
  occassion_id?: number;
  verse_text: string
  reference: string;
  // content: string;
  occasion_name?: string;
  occasion_index?: string;
  language: Language;
  category: VerseCategory;
  description: string;
  author: string;
  isActive: boolean;
  createdAt: Date;
  updatedAt: Date;
  notes: string
  is_default: boolean;
}

export const getCategoryDisplayName = (category: VerseCategory) => {
  switch (category) {
    case VerseCategory.WEDDING:
      return 'Wedding Anniversary';
    case VerseCategory.BIRTHDAY:
      return 'Birthday';
    case VerseCategory.BAPTISM:
      return 'Baptism Anniversary';
    case VerseCategory.COMMUNION:
      return 'Communion Anniversary';
    case VerseCategory.INSPIRATIONAL:
      return 'Inspirational';
    default:
      return category;
  }
};

export const getLanguageDisplayName = (language: Language) => {
  switch (language) {
    case Language.TAMIL:
      return 'Tamil';
    case Language.ENGLISH:
      return 'English';
    case Language.ENGLISH_US:
      return 'English(US)';
    case Language.SPANISH:
      return 'Spanish';
    case Language.MALAYALAM:
      return 'Malayalam';
    case Language.FRENCH:
      return 'French';
    case Language.GERMAN:
      return 'German';
    case Language.CHINESE:
      return 'Chinese';
    case Language.HINDI:
      return 'Hindi';
    case Language.ARABIC:
      return 'Arabic';
    case Language.PORTUGUESE:
      return 'Portugese';
    case Language.JAPANESE:
      return 'Japanese';
    case Language.RUSSIAN:
      return 'Russian';
    default:
      return language;
  }
};
